import { t } from "i18next";

class CurrencyUtils {

  static currency(amount) {
      try {
          if (amount !== undefined && amount !== null) {
              return amount.toLocaleString('pl-PL', { style: 'currency', currency: 'PLN' });
          } else {
              return t('global.empty')
          }
      } catch (ex) {
          console.err("CurrencyUtils error ->", ex)
          return t('global.currency-format-error')
      }
  }

}

export default CurrencyUtils;